var _rect, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWhiteRounded = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#F4F4F4"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.857 31.997H9.974A1.973 1.973 0 018 30.023v-4.258c0-1.091.883-1.975 1.974-1.975h5.61v-6.233c0-1.09.883-1.974 1.974-1.974h6.234v16.362h-4.936v.052z",
  fill: "#FFC517"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M30.031 31.997h-6.239V9.974c0-1.09.883-1.974 1.974-1.974h4.26C31.116 8 32 8.883 32 9.974v20.05c-.054 1.09-.929 1.973-1.969 1.973z",
  fill: "#F57E02"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.946 23.79v6.234c0 1.09-.883 1.974-1.974 1.974H23.74V15.584l8.207 8.207z",
  fill: "url(#white-rounded_svg__paint0_linear_1392_2542)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "white-rounded_svg__paint0_linear_1392_2542",
  x1: 23.766,
  y1: 23.791,
  x2: 31.954,
  y2: 23.791,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E96F0B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F37901"
})))));
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiByeD0iMjAiIGZpbGw9IiNGNEY0RjQiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xOC44NTY1IDMxLjk5NzVIOS45NzQyQzguODgzMTEgMzEuOTk3NSA4IDMxLjExNDQgOCAzMC4wMjMzVjI1Ljc2NDZDOCAyNC42NzM1IDguODgzMTEgMjMuNzkwNCA5Ljk3NDIgMjMuNzkwNEgxNS41ODRWMTcuNTU3NEMxNS41ODQgMTYuNDY2MyAxNi40NjcxIDE1LjU4MzIgMTcuNTU4MiAxNS41ODMySDIzLjc5MlYzMS45NDU1SDE4Ljg1NjVWMzEuOTk3NVoiIGZpbGw9IiNGRkM1MTciLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMC4wMzE0IDMxLjk5NzVIMjMuNzkyVjkuOTc0MTRDMjMuNzkyIDguODgzMDUgMjQuNjc1MSA3Ljk5OTk0IDI1Ljc2NjIgNy45OTk5NEgzMC4wMjU4QzMxLjExNjkgNy45OTk5NCAzMiA4Ljg4MzA1IDMyIDkuOTc0MTRWMzAuMDI0MUMzMS45NDU2IDMxLjExNDQgMzEuMDcxMyAzMS45OTc1IDMwLjAzMTQgMzEuOTk3NVoiIGZpbGw9IiNGNTdFMDIiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0zMS45NDYgMjMuNzkwOFYzMC4wMjM5QzMxLjk0NiAzMS4xMTQ3IDMxLjA2MjkgMzEuOTk3NyAyOS45NzIxIDMxLjk5NzdIMjMuNzM5VjE1LjU4MzhMMzEuOTQ2IDIzLjc5MDhaIiBmaWxsPSJ1cmwoI3BhaW50MF9saW5lYXJfMTM5Ml8yNTQyKSIvPgo8ZGVmcz4KPGxpbmVhckdyYWRpZW50IGlkPSJwYWludDBfbGluZWFyXzEzOTJfMjU0MiIgeDE9IjIzLjc2NjMiIHkxPSIyMy43OTA4IiB4Mj0iMzEuOTUzOCIgeTI9IjIzLjc5MDgiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iI0U5NkYwQiIvPgo8c3RvcCBvZmZzZXQ9IjEiIHN0b3AtY29sb3I9IiNGMzc5MDEiLz4KPC9saW5lYXJHcmFkaWVudD4KPC9kZWZzPgo8L3N2Zz4K";
export { SvgWhiteRounded as ReactComponent };